/* Enlacé PDP additions. The existing configurator remains the sole cart owner. */
(function () {
  'use strict';
  const key = '__veyraEnlaceSections20261018';
  if (window[key]) { window[key].init(document); return; }
  const instances = new Map();
  const overlaySelector = 'dialog[open], .vh-search[open], [aria-modal="true"]:not([hidden]), cart-drawer.active, .upcartPopupShow, #upcart-container [role="dialog"], [class*="upcart" i][class*="drawer" i], [class*="upcart" i][class*="overlay" i]';
  const editingSelector = 'input:not([type="radio"]):not([type="checkbox"]):not([type="button"]):not([type="submit"]):not([type="hidden"]), textarea, select, [contenteditable="true"]';

  function onScreen(node) {
    if (node.hidden || node.closest('[hidden], [aria-hidden="true"]')) return false;
    const rect = node.getBoundingClientRect();
    const style = getComputedStyle(node);
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 &&
      rect.top < window.innerHeight && rect.left < window.innerWidth &&
      style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) !== 0;
  }

  function initRoot(root) {
    if (instances.has(root)) return;
    const lifecycle = new AbortController();
    const signal = lifecycle.signal;
    const wrapper = root.closest('.shopify-section') || root;
    const config = root.dataset.configId ? document.getElementById(root.dataset.configId) : document.querySelector('veyra-duo-config');
    const mainButton = config?.querySelector('[data-vd-add]');
    const bar = root.querySelector('[data-enl2-sticky]') || wrapper.querySelector('[data-enl2-sticky]');
    const spacer = root.querySelector('[data-enl2-sticky-spacer]') || wrapper.querySelector('[data-enl2-sticky-spacer]');
    const stickyButton = bar?.querySelector('[data-enl2-sticky-button]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const observers = [];
    const requests = new Set();
    let frame = 0;

    function firstMissingControl() {
      if (!config) return null;
      for (const group of config.querySelectorAll('[data-choice]')) {
        if (!group.querySelector('input:checked')) return group.querySelector('input:not(:disabled)');
      }
      for (const input of config.querySelectorAll('[data-name]')) {
        const value = input.value.normalize('NFC').trim().toUpperCase();
        if (!value || [...value].length > Number(config.dataset.max || 10) || !/^\p{Script=Latin}[\p{Script=Latin}\p{M} -]*$/u.test(value)) return input;
      }
      return null;
    }

    function configure() {
      if (!config || !mainButton) return;
      const target = firstMissingControl() || mainButton;
      const destination = target.closest('.vd-card') || config;
      destination.scrollIntoView({behavior: motion.matches ? 'instant' : 'smooth', block: 'center'});
      if (!target.disabled) target.focus({preventScroll: true});
      schedule();
    }

    function refresh() {
      frame = 0;
      if (!bar || !stickyButton || !spacer || !config || !mainButton || !root.isConnected) return;
      const editing = document.activeElement?.matches(editingSelector);
      const modalOpen = Array.from(document.querySelectorAll(overlaySelector)).some(onScreen);
      const available = config.dataset.available === 'true' && bar.dataset.available !== 'false';
      const shown = available && mainButton.getBoundingClientRect().bottom <= 0 && !editing && !modalOpen;
      const complete = !firstMissingControl();
      const label = complete ? bar.dataset.labelAdd : bar.dataset.labelDesign;
      if (label && stickyButton.dataset.label !== label) {
        stickyButton.dataset.label = label;
        stickyButton.textContent = label;
        const arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '→';
        stickyButton.appendChild(arrow);
      }
      stickyButton.disabled = !available || mainButton.disabled || !config.ready;
      if (bar.hidden === shown) bar.hidden = !shown;
      if (spacer.hidden === shown) spacer.hidden = !shown;
      if (shown) {
        const height = `${bar.getBoundingClientRect().height}px`;
        if (spacer.style.getPropertyValue('--enl2-sticky-height') !== height) spacer.style.setProperty('--enl2-sticky-height', height);
      }
    }

    function schedule() {
      if (!frame && !signal.aborted) frame = requestAnimationFrame(refresh);
    }

    root.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-enl2-configure]');
      if (!trigger || !root.contains(trigger) || !config) return;
      event.preventDefault();
      configure();
    }, {signal});

    if (bar && stickyButton && spacer && mainButton) {
      stickyButton.addEventListener('click', () => {
        if (stickyButton.disabled || mainButton.disabled || !config.ready) return;
        if (firstMissingControl()) configure();
        else {
          // Exactly one delegated click: validation, properties, locks and UpCart stay native.
          mainButton.click();
        }
        refresh();
      }, {signal});
      window.addEventListener('scroll', schedule, {passive: true, signal});
      window.addEventListener('resize', schedule, {passive: true, signal});
      window.addEventListener('orientationchange', schedule, {passive: true, signal});
      window.visualViewport?.addEventListener('resize', schedule, {passive: true, signal});
      document.addEventListener('focusin', schedule, {signal});
      document.addEventListener('focusout', schedule, {signal});
      document.addEventListener('veyra:cart-added', schedule, {signal});
      document.addEventListener('transitionend', schedule, {signal});
      config.addEventListener('input', schedule, {signal});
      config.addEventListener('change', schedule, {signal});
      config.querySelector('[data-copy]')?.addEventListener('click', schedule, {signal});
      const mutation = new MutationObserver((records) => {
        if (records.some((record) => !root.contains(record.target) && !bar.contains(record.target) && record.target !== spacer)) schedule();
      });
      mutation.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-hidden', 'disabled', 'data-available']});
      observers.push(mutation);
      if ('IntersectionObserver' in window) {
        const intersection = new IntersectionObserver(schedule, {threshold: 0});
        intersection.observe(mainButton);
        observers.push(intersection);
      }
      if ('ResizeObserver' in window) {
        const resize = new ResizeObserver(schedule);
        resize.observe(config);
        resize.observe(bar);
        observers.push(resize);
      }
      window.customElements?.whenDefined('veyra-duo-config').then(schedule);
      refresh();
    }

    root.querySelectorAll('form[data-enl2-newsletter]').forEach((form) => {
      const email = form.querySelector('input[type="email"][name="email"]');
      const submit = form.querySelector('button[type="submit"]');
      const status = form.querySelector('[data-newsletter-status]') || root.querySelector('[data-newsletter-status]');
      if (!email || !submit || !status) return;
      const controls = form.querySelector('[data-enl2-newsletter-controls]');
      if (controls) controls.disabled = false;
      const initialLabel = submit.innerHTML;
      let sending = false;
      let accepted = false;
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      function showStatus(message, error) {
        status.textContent = message || '';
        status.hidden = false;
        status.dataset.state = error ? 'error' : 'success';
      }
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (sending || accepted) return;
        email.value = email.value.trim();
        if (!email.value || !email.validity.valid || email.value.length > 254) {
          email.setAttribute('aria-invalid', 'true');
          showStatus(form.dataset.invalidMessage, true);
          email.focus();
          return;
        }
        const trap = form.querySelector('[name="website"]');
        if ((trap && trap.value) || typeof window.fetch !== 'function') {
          showStatus(form.dataset.errorMessage, true);
          return;
        }
        sending = true;
        submit.disabled = true;
        email.readOnly = true;
        email.removeAttribute('aria-invalid');
        status.hidden = true;
        submit.textContent = form.dataset.sendingMessage;
        form.setAttribute('aria-busy', 'true');
        const request = new AbortController();
        requests.add(request);
        const timeout = window.setTimeout(() => request.abort(), 20000);
        try {
          const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=Wtt7bE', {
            method: 'POST', mode: 'cors', credentials: 'omit',
            headers: {'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-10-15'},
            body: JSON.stringify({data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Veyra Enlacé PDP newsletter 2026-10-18',
                profile: {data: {type: 'profile', attributes: {
                  email: email.value, locale: form.dataset.locale || document.documentElement.lang || 'de',
                  subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}}
                }}}
              },
              relationships: {list: {data: {type: 'list', id: 'YwXfP3'}}}
            }}),
            signal: request.signal
          });
          if (response.status !== 202) {
            const failure = new Error('Subscription not accepted');
            failure.rateLimited = response.status === 429;
            throw failure;
          }
          accepted = true;
          try { localStorage.setItem('veyra-card-optin-accepted-v1', String(Date.now())); } catch (_) { /* Private browsing may deny storage. */ }
          if (!signal.aborted) {
            form.reset();
            showStatus(form.dataset.successMessage, false);
          }
        } catch (failure) {
          if (!signal.aborted) showStatus(failure.name === 'AbortError' ? form.dataset.timeoutMessage : failure.rateLimited ? (form.dataset.rateMessage || form.dataset.errorMessage) : form.dataset.errorMessage, true);
        } finally {
          window.clearTimeout(timeout);
          requests.delete(request);
          sending = false;
          if (!signal.aborted) {
            submit.disabled = accepted;
            email.readOnly = accepted;
            submit.innerHTML = initialLabel;
            form.removeAttribute('aria-busy');
          }
        }
      }, {signal});
      email.addEventListener('input', () => {
        if (!sending && !accepted) { status.hidden = true; email.removeAttribute('aria-invalid'); }
      }, {signal});
    });

    instances.set(root, () => {
      lifecycle.abort();
      if (frame) cancelAnimationFrame(frame);
      observers.forEach((observer) => observer.disconnect());
      requests.forEach((request) => request.abort());
      if (bar) bar.hidden = true;
      if (spacer) spacer.hidden = true;
    });
  }

  function init(scope) {
    if (scope.matches?.('.enl2-sections')) initRoot(scope);
    scope.querySelectorAll('.enl2-sections').forEach(initRoot);
  }
  window[key] = {init};
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((destroy, root) => {
      if (root === event.target || event.target.contains(root)) { destroy(); instances.delete(root); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once: true});
  else init(document);
}());
